<!-- Modal Header -->
<div class="modal-header">
  <h4 class="modal-title">Generate Form J</h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
</div>

<div class="modal-body">
  <div class="p-2" style="background-color: lavender">
    <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isEPF" name="isEPF">EPF LOAN</mat-slide-toggle>
  </div>
  <div class="bg-light p-4 d-flex gap-3 align-items-end flex-wrap">
    @if (isEPF === true) {
      <div class="flex-fill">
        <mat-form-field subscriptSizing="dynamic" class="w-100">
          <mat-label>Months</mat-label>
          <input matInput type="number" [(ngModel)]="selectedMonths" (keypress)="sharedService.isNumberKey($event)" />
        </mat-form-field>
      </div>
      <div class="flex-fill">
        <mat-form-field subscriptSizing="dynamic" class="w-100">
          <mat-label>On Hand Amount</mat-label>
          <input matInput type="number" [(ngModel)]="onHandAmount" (keypress)="sharedService.isNumberKey($event)" />
        </mat-form-field>
      </div>
      <div class="w-100 d-flex justify-content-end">
        <button class="btn btn-primary" (click)="getEPFScheduleAndCalculate()" [disabled]="disabledSubmit">Calculate</button>
      </div>
    } @else {
      <div class="flex-fill">
        <mat-form-field subscriptSizing="dynamic" class="w-100">
          <mat-label>Months</mat-label>
          <input matInput type="number" [(ngModel)]="monthsCount" (keypress)="sharedService.isNumberKey($event)" />
        </mat-form-field>
      </div>
      <div class="flex-fill">
        <mat-form-field subscriptSizing="dynamic" class="w-100">
          <mat-label>Amount</mat-label>
          <input matInput type="number" [(ngModel)]="amount" (keypress)="sharedService.isNumberKey($event)" />
        </mat-form-field>
      </div>
      <div class="w-100 d-flex justify-content-end"><button class="btn btn-primary" (click)="addSchedule()" [disabled]="disabledSubmit">Add Schedule</button></div>
    }
  </div>
  @if (isEPF === false && schedule().length > 0) {
    <table class="table">
      <thead>
        <tr>
          <th class="text-center">Months</th>
          <th class="text-center">Amount (RM)</th>
        </tr>
      </thead>
      <tbody>
        @for (s of schedule(); track s; let i = $index) {
          <tr>
            <td class="text-center">{{ s.monthsCount }}</td>
            <td class="text-center">
              {{ s.amount }}
              <h4 class="text-danger d-inline ms-1" style="cursor: pointer" (click)="removeSchedule(i)">
                <i class="fas fa-times"></i>
              </h4>
            </td>
          </tr>
        }
      </tbody>

      <tfoot>
        <tr>
          <th class="text-center">{{ totalMonths() }} months</th>
          <th class="text-center">RM {{ total() }}</th>
        </tr>
      </tfoot>
    </table>
  }

  <div class="d-flex flex-column gap-4 mt-5">
    <div class="card">
      <div class="card-body">
        <h4>Pinjaman (Pokok): RM {{ formJ.Principal }}</h4>
        <!-- <h4 *ngIf="selectedMonths>1">Payment : RM {{payment}}</h4>
                <h4 *ngIf="selectedMonths>1">Total Payment : RM {{totalPayment}}</h4> -->
        @if (isEPF === true && selectedMonths - 1 > 0) {
          <h4 class="text-primary">Monthly Payment : RM {{ epfMonthly }} x {{ selectedMonths - 1 }} months</h4>
        }
        <h4>Last Payment Amount : RM {{ formJ.LastPayment }}</h4>
      </div>
    </div>
    <div class="d-grid grid-2-col gap-4">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Form J Stamp Date</mat-label>
        <input matInput readonly [matDatepicker]="formJDatePicker" name="formJDate" [(ngModel)]="formJ.Date" [min]="sharedService.getTodayDate()" required />
        <mat-datepicker-toggle matSuffix [for]="formJDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #formJDatePicker name="formJDate"></mat-datepicker>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Receipt Number</mat-label>
        <input matInput type="text" [(ngModel)]="formJ.ReceiptNumber" />
      </mat-form-field>
    </div>
    <div></div>
    <div class="d-flex justify-content-end align-itmes-right">
      <button class="btn btn-primary" (click)="generateFormJ()" [disabled]="disabledSubmit">Generate</button>
    </div>
  </div>
</div>
